var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 5.50006C13.5273 5.49913 15.0056 6.03883 16.173 7.02356L19.443 3.90956C18.1877 2.75211 16.6799 1.90316 15.0393 1.43009C13.3987 0.957025 11.6704 0.872862 9.99161 1.18428C8.31279 1.4957 6.72967 2.19413 5.36787 3.22415C4.00608 4.25416 2.90311 5.5874 2.14648 7.11806L5.83298 9.95956C6.26292 8.6631 7.08986 7.53478 8.19669 6.73441C9.30351 5.93404 10.6341 5.5022 12 5.50006Z",
    fill: "#D94F3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 12.0002C5.50092 11.3065 5.61335 10.6176 5.833 9.95966L2.1465 7.11816C1.39242 8.63511 1 10.3061 1 12.0002C1 13.6942 1.39242 15.3652 2.1465 16.8822L5.833 14.0407C5.61335 13.3827 5.50092 12.6938 5.5 12.0002Z",
    fill: "#F2C042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.55 10H12.05V14.5H18C17.646 15.7724 16.8351 16.8694 15.7225 17.581L19.3805 20.401C21.718 18.303 23.0915 14.8915 22.55 10Z",
    fill: "#5085ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.721 17.5815C14.5905 18.2286 13.3017 18.5469 12 18.5005C10.6341 18.4984 9.30351 18.0665 8.19669 17.2662C7.08986 16.4658 6.26292 15.3375 5.83298 14.041L2.14648 16.8825C3.05705 18.7181 4.46171 20.2631 6.20246 21.344C7.9432 22.4248 9.95099 22.9985 12 23.0005C14.6962 23.0738 17.3243 22.1478 19.379 20.4005L15.721 17.5815Z",
    fill: "#57A75C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.73ce9ad56ef3bf42497e1a7bded8a369.svg";
export { ForwardRef as ReactComponent };